import { AppStatus } from '@/redux'
import { Topic } from '../../../utils/hooks/topic' //WTF!
import { APIClient } from '@/services'
import { checkSignupCompletion } from './checkSignupCompletion'
import { Profile } from '@/types'

export const ensureLoggedInTopic = Topic.named<boolean>('isLoggedIn')
export const ensureProfileDetailsTopic = Topic.named<boolean>('ensureUserDetails')

export async function ensureProfileDetails(profile: Profile) {
  const signupComplete = await checkSignupCompletion(profile)
  if (!signupComplete.isComplete) {
    // @ts-ignore
    AppStatus.setModal(signupComplete.modal ?? signupComplete.nextStep)
    await ensureProfileDetailsTopic.wait(null)
  }

  // await ensureEmailVerified(profile)
}

export async function ensureProfileLogged() {
  // const profile = QueryKeys.me.getData()

  // if (getIsLoggedIn() && !!profile) {
  //   return await ensureProfileDetails(profile)
  // }

  const isLoggedIn = APIClient.UnknownProfile.maybeOpenRegistrationWall()

  if (!isLoggedIn) {
    throw new Error('User is not logged in', { cause: 'ensureProfileComplete' })
  }

  return true

  // const updatedProfile = QueryKeys.me.getData()
  // return await ensureProfileDetails(updatedProfile)
}
